module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAARCAYAAAFMandsAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAQpJREFUeNpi+P//P8N/H58GEA1iLIAJMCDLAAQQI1gaCBiBIv8hDKgIQABBGL6+EB4IbN7MyMSABQAEEMzEBDAGmwo1DAYwtDERNAMggGDWGwDlzmOx0xDonAtMQAUJcAVA96HQIHGgPHY3owGirAMIIHjYABUqAMkEqOQCoOQDZFNAHHk0Ex4CFSmAQmYBkBOPwxkLkYNuIZokWBMLmkAilD0fW9CCTHCAYrhpLFBOPA53LCTCFwTCASDAEAogigSA5AQ83oa5tQBowAf0KAFpvoDFKfjAQyA2ABkGCk+QE+9jsY0BzUXYxEBAkQnJjxgRAk1uiUjJDps3iUuGhJMpFbxDpYClQhQDAO1qptc9mrUPAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./public/hws/images/wrong.png
// module id = 68
// module chunks = 0